module.exports = __webpack_public_path__ + "img/liaocheng.0d843ccd.jpg";